<script setup lang="ts">
import { IUser, useUserStore } from "@/modules/user-module";
import { computed, ComputedRef } from "vue";
import { useI18n } from "vue-i18n";

const userStore = useUserStore();
const { t } = useI18n();
const user: ComputedRef<null | IUser> = computed(() => userStore.user);
</script>

<template>
  <nav class="footer-navigation">
    <RouterLink :to="{ name: 'HomeView' }">
      {{ t("nav.home") }}
    </RouterLink>
    <RouterLink :to="{ name: 'ReceiveView' }">
      {{ t("nav.receive") }}
    </RouterLink>
    <RouterLink :to="{ name: 'SpendView' }">{{ t("nav.spend") }}</RouterLink>
    <template v-if="user">
      <RouterLink :to="{ name: 'ProfileInvite' }">
        {{ t("nav.profile") }}
      </RouterLink>
      <RouterLink :to="{ name: 'ProfileTariffs' }">
        {{ t("footer.nav.tariffs") }}
      </RouterLink>
    </template>
    <RouterLink :to="{ name: 'DocumentView', params: { id: 'contacts' } }">
      {{ t("footer.nav.contacts") }}
    </RouterLink>
    <a href="https://support.rc.today/sign-in?source=cs" target="_blank">
      {{ t("nav.support") }}
    </a>
    <RouterLink
      :to="{ name: 'DocumentView', params: { id: 'klientskoe-soglashenie' } }"
    >
      {{ t("footer.nav.customerAgreement") }}
    </RouterLink>
    <RouterLink :to="{ name: 'DocumentView', params: { id: 'agreements' } }">
      {{ t("footer.nav.agreements") }}
    </RouterLink>
    <RouterLink :to="{ name: 'DocumentView', params: { id: 'policy' } }">
      {{ t("footer.nav.policy") }}
    </RouterLink>
    <RouterLink :to="{ name: 'DocumentView', params: { id: 'personal-data' } }">
      {{ t("footer.nav.personalData") }}
    </RouterLink>
    <RouterLink :to="{ name: 'DocumentView', params: { id: 'rules' } }">
      {{ t("footer.nav.rules") }}
    </RouterLink>
    <RouterLink
      :to="{ name: 'DocumentView', params: { id: 'licenzionnoe-soglashenie' } }"
    >
      {{ t("footer.nav.licenceAgreement") }}
    </RouterLink>
  </nav>
</template>

<style scoped lang="scss">
.footer-navigation {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: calc($base-space * 3) calc($base-space * 6);

  > a {
    @include body-s();
    color: var(--color-semantic-content-normal-contrast-secondary);

    &:hover {
      color: var(--color-semantic-content-normal-contrast-primary);
    }
  }
}
</style>
